import { HANDLE_UNCAUGHT_EXCEPTION } from 'actions/exceptions/handleUncaughtException';
import { HANDLE_CONNECTION_EXCEPTION } from 'actions/exceptions/handleConnectionException';
import { HANDLE_SERVER_EXCEPTION } from 'actions/exceptions/handleServerException';
import { CLEAR_EXCEPTION, CLOSE_EXCEPTION } from 'actions/exceptions/clearException';

/* The exceptions reducer */
// eslint-disable-next-line default-param-last
function exceptions(state = {
  items: []
}, action) {
  switch (action.type) {
    case HANDLE_UNCAUGHT_EXCEPTION:
    case HANDLE_CONNECTION_EXCEPTION:
    case HANDLE_SERVER_EXCEPTION:
      return {
        ...state,
        items: state.items.concat({
          type: 2,
          id: new Date().valueOf(),
          code: action.code,
          message: action.message
        })
      };
    case CLEAR_EXCEPTION:
      state.items.splice(action.index, 1);
      return {
        ...state,
        items: [
          ...state.items
        ]
      };
    case CLOSE_EXCEPTION:
      state.items[action.index].closing = true;
      return {
        ...state,
        items: [
          ...state.items
        ]
      };

    default:
      return state;
  }
}

export default exceptions;
